import { readSheet } from 'read-excel-file/universal';
import writeXlsxFile, { SheetData } from 'write-excel-file/universal';

export interface ExcelSheet {
  name: string;
  rows: SheetData;
  columnWidths?: number[];
}

export function createExcelWorkbookBlob(sheets: ExcelSheet[]): Promise<Blob> {
  return writeXlsxFile(
    sheets.map((sheet) => ({
      data: sheet.rows,
      sheet: sheet.name,
      columns: sheet.columnWidths?.map((width) => ({ width })),
    })),
  ).toBlob();
}

export async function readFirstExcelColumn(
  data: ArrayBuffer | ArrayBufferView,
): Promise<string[]> {
  const rows = await readSheet(toArrayBuffer(data));
  const values: string[] = [];

  for (const row of rows) {
    const value = row[0];
    if (value !== null && value !== '') {
      values.push(value.toString().trim());
    }
  }

  return values;
}

function toArrayBuffer(data: ArrayBuffer | ArrayBufferView): ArrayBuffer {
  if (data instanceof ArrayBuffer) {
    return data;
  }

  const copy = new Uint8Array(data.byteLength);
  copy.set(new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
  return copy.buffer;
}